"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractCssDataFromPage = exports.createRefArrayMap = void 0;
var consts_1 = require("./consts");
var internal_1 = require("./utils/internal");
var masterPageChildren = function (page) { return page.children; };
var mobilePageChildren = function (page) { return page.mobileComponents; };
var componentChildren = function (component) { return component.components; };
var flat = function (arr) { return [].concat.apply([], arr); };
var children = function (component, isMobile) {
    if (isMobile === void 0) { isMobile = false; }
    var childrenCollected = [];
    if (isMobile) {
        var comps = mobilePageChildren(component);
        if (comps) {
            childrenCollected = comps;
        }
    }
    else {
        childrenCollected = flat([masterPageChildren(component), componentChildren(component)]);
    }
    return childrenCollected;
};
function recursiveCallFunc(compsArray, func) {
    if (compsArray) {
        compsArray.forEach(function (comp) {
            if (comp) {
                func(comp);
                recursiveCallFunc(children(comp), func);
            }
        });
    }
}
function runForCompsRecursively(pageJson, isMobileView, func) {
    var compsArray = [];
    if (pageJson.structure) {
        if (isMobileView) {
            compsArray = children(pageJson.structure, isMobileView);
        }
        else {
            compsArray = children(pageJson.structure);
        }
        recursiveCallFunc(compsArray, func);
    }
    return compsArray;
}
function getCompLayoutMapFromPage(pageJson, isMobileView) {
    var compLayoutMap = {};
    var callbackfn = function (comp) {
        if (comp.layout) {
            compLayoutMap[comp.styleId] = comp.layout;
        }
    };
    runForCompsRecursively(pageJson, isMobileView, callbackfn);
    return compLayoutMap;
}
function removeHash(id) {
    return id.replace('#', '');
}
/**
 * Inside helper function which runs a callback for a map of theme data items
 * @param themeDataItems - map of theme data items
 * @param cb - callback to run for all of them.
 */
function forStyleItems(themeDataItems, cb) {
    Object.keys(themeDataItems).forEach(function (id) {
        if (id === consts_1.THEME_DATA) {
            return;
        }
        var themeDataItem = themeDataItems[id];
        cb(themeDataItem, id);
    });
}
/**
 * Creates and returns a map of refs between items, gathered from themeDataItems and masterThemeDataItems
 * @param themeDataItems - theme data from page
 * @param masterThemeDataItems - theme data from master page
 * @param logger - site-assets logger object to throw warnings if needed
 */
function createRefArrayMap(themeDataItems, masterThemeDataItems, logger) {
    if (masterThemeDataItems === void 0) { masterThemeDataItems = {}; }
    var refArrayMap = {};
    // Map refArrays 1st pass - RefArrays
    forStyleItems(themeDataItems, function (themeDataItem, id) {
        var _a;
        if (themeDataItem.type === 'RefArray') {
            (_a = themeDataItem.values) === null || _a === void 0 ? void 0 : _a.forEach((function (hashedStyleId) {
                var styleId = removeHash(hashedStyleId);
                var dataItem = themeDataItems[styleId];
                if (!dataItem) {
                    dataItem = masterThemeDataItems[styleId];
                }
                if (!dataItem) {
                    logger.warn("Missing dataItem for styleId=" + styleId + ", SHOULD NOT HAPPEN");
                }
                else if (!dataItem.type) {
                    logger.warn("Missing type for styleId=" + styleId + ", SHOULD NOT HAPPEN");
                }
                else {
                    if (dataItem.type === 'VariantRelation') {
                        if (!dataItem.to) {
                            logger.warn('VariantRelation missing "to" field, SHOULD NOT HAPPEN');
                        }
                        else {
                            refArrayMap[internal_1.createRobustKey(removeHash(dataItem.to), id)] = id;
                        }
                    }
                    else if (dataItem.type === 'ComponentStyle' || dataItem.type === 'TopLevelStyle') {
                        if (!dataItem.id) {
                            logger.warn(styleId + " - " + dataItem.type + " missing \"id\" field, SHOULD NOT HAPPEN");
                        }
                        else {
                            refArrayMap[internal_1.createRobustKey(dataItem.id, id)] = id;
                        }
                    }
                    else {
                        logger.warn("Unsupported styleItem of type=" + dataItem.type + " for styleId=" + dataItem.id + " in stylable-santa-flatten");
                    }
                }
            }));
        }
    });
    return refArrayMap;
}
exports.createRefArrayMap = createRefArrayMap;
/**
 * Gathers stylable, layout and ref data from pages and updates stylableCssSiteData with it.
 * @param logger - site-assets logger object to throw warnings if needed
 * @param pageJson - page json to scan
 * @param stylableCssSiteData - StylableCssSiteData object to update with data on pages
 * @param isMobileView - iff true, uses *mobile* item layout data
 * @param masterPage - master json to scan (not required, but usually needed if pageJson is not masterPage)
 */
function extractCssDataFromPage(logger, pageJson, stylableCssSiteData, isMobileView, masterPage) {
    var _a, _b;
    var themeDataItems = (_a = pageJson === null || pageJson === void 0 ? void 0 : pageJson.data) === null || _a === void 0 ? void 0 : _a.theme_data;
    var masterThemeDataItems = (_b = masterPage === null || masterPage === void 0 ? void 0 : masterPage.data) === null || _b === void 0 ? void 0 : _b.theme_data;
    if (!themeDataItems) {
        return;
    }
    // Get layout of every component in page:
    var compLayoutMap = getCompLayoutMapFromPage(pageJson, isMobileView);
    // Create a map for ref items (origin -> refArrayId)
    var refArrayMap = createRefArrayMap(themeDataItems, masterThemeDataItems, logger);
    // 1st phase:
    // Run on all style items in page and store all the ones with stylable:
    forStyleItems(themeDataItems, function (themeDataItem, id) {
        if (themeDataItem.style &&
            themeDataItem.style.properties &&
            themeDataItem.style.properties['$st-css'] !== undefined) {
            // Filter out style items which are used by ref, these are scanned in 2nd phase
            if (!Object.keys(refArrayMap).find(function (key) { return internal_1.getStyleIdFromRobustKey(key) === id; })) {
                // Store style item:
                stylableCssSiteData.set(id, {
                    content: themeDataItem.style.properties['$st-css'],
                    styleId: id,
                    compLayout: compLayoutMap[id]
                });
            }
        }
    });
    // 2nd phase:
    // Run for all refs in collected refArrayMap:
    Object.keys(refArrayMap).forEach(function (key) {
        // Get styleId and refId from robust key:
        var styleIdTarget = internal_1.getStyleIdFromRobustKey(key);
        var refIdSource = internal_1.getRefIdFromRobustKey(key);
        // Try to get styleItem from page:
        var styleItem = themeDataItems[styleIdTarget];
        // If styleItem not on page try masterPage:
        if (!styleItem && masterThemeDataItems) {
            styleItem = masterThemeDataItems[styleIdTarget];
        }
        // If its a stylable style item, add to data
        if (styleItem &&
            styleItem.style &&
            styleItem.style.properties &&
            styleItem.style.properties['$st-css'] !== undefined) {
            stylableCssSiteData.set(key, {
                content: styleItem.style.properties['$st-css'],
                styleId: styleIdTarget,
                refArrayId: refIdSource,
                compLayout: compLayoutMap[refIdSource]
            });
        }
    });
}
exports.extractCssDataFromPage = extractCssDataFromPage;
//# sourceMappingURL=santa-utils.js.map